import { ContoVO } from "./contoVO";

export class ContoCapienzaVO {
    esercizio: string;
    periodo: string;
    conti: ContoVO[];
  }